import axios from 'axios';

export const customFetch = async (
  url,
  method,
  auth = false,
  params = {},
  data = null,
) => {
  const rawBase = (process.env.REACT_APP_END_POINT || '/backend').replace(/\/+$/, '');
  const baseURL = rawBase.endsWith('/backend') ? rawBase : `${rawBase}/backend`;

  if (auth) {
    const token = JSON.parse(sessionStorage.getItem('token') || '{}');
    const headers = {
      accept: 'application/json',
      Authorization: 'Bearer ' + token,
      'Cache-Control': 'no-cache',
    };
    const res = await axios({
      baseURL,
      url,
      method,
      headers,
      params,
      data,
    }).catch((error) => {
      //sessionStorage.removeItem('token');
      console.log(error);
      switch (error.response?.status) {
        case 401: // no share page
        case 404: // no pdf
          break;
        case 422: // 無法處理的實體 (參數錯誤)
          console.error('API參數錯誤 (422):', error.response.data);
          break;
        //default:
        //window.location.href = '/';
        //break;
      }
      // 返回帶有錯誤信息的對象
      return {
        data: null,
        error: error.response?.data || error.message || '未知錯誤'
      };
    });

    // 檢查是否有錯誤對象被返回
    if (res && res.error) {
      throw new Error(typeof res.error === 'object' ? JSON.stringify(res.error) : res.error);
    }

    return res?.data; // 安全訪問 data
  } else {
    const headers = {
      'Content-Type': 'application/json',
    };
    const res = await axios({ baseURL, url, method, headers, params, data });
    return res.data;
  }
};